import { render } from "./PageLogin.vue?vue&type=template&id=fcd2c342&scoped=true&ts=true"
import script from "./PageLogin.vue?vue&type=script&lang=ts"
export * from "./PageLogin.vue?vue&type=script&lang=ts"

import "./PageLogin.vue?vue&type=style&index=0&id=fcd2c342&scoped=true&lang=css"

import exportComponent from "D:\\project\\CDM_QR-Access-Control-System-3\\DoorWebApp_Vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fcd2c342"]])

export default __exports__